import React from "react";
import { Fish, Anchor, Ship, Package } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const highlights = [{
  title: "Wild-Caught Seafood",
  description: "Sourced directly from the open waters, never farmed, ensuring natural flavor and quality.",
  icon: Fish
}, {
  title: "Responsible Harvesting",
  description: "Adhering to strict quotas and seasonal guidelines to protect delicate marine ecosystems.",
  icon: Anchor
}, {
  title: "Supporting Local",
  description: "Partnering with independent Gulf Coast captains to sustain traditional fishing communities.",
  icon: Ship
}, {
  title: "Careful Handling",
  description: "Expertly cut, flash-frozen, and shipped with precision to ensure peak freshness upon arrival.",
  icon: Package
}];
export default function SustainabilityHighlights() {
  return <section id="sustainability-highlights" className="relative w-full overflow-hidden bg-background py-24 text-foreground md:py-40">
      {}
      <div className="pointer-events-none absolute inset-0 flex justify-between px-8 opacity-5">
        <div className="h-full w-px bg-foreground"></div>
        <div className="h-full w-px bg-foreground hidden md:block"></div>
        <div className="h-full w-px bg-foreground hidden lg:block"></div>
        <div className="h-full w-px bg-foreground"></div>
      </div>

      {}
      <div className="pointer-events-none absolute right-8 top-24 hidden origin-bottom-right -rotate-90 text-xs tracking-widest text-muted-foreground font-mono lg:block">
        30° 24' 42" N // 88° 49' 42" W
      </div>

      <div className="mx-auto max-w-7xl px-6 md:px-8 relative z-10">
        {}
        <div className="mb-16 flex flex-col items-center text-center md:mb-24">
          <span className="mb-4 font-mono text-sm font-medium uppercase tracking-widest text-primary">
            Our Commitment
          </span>
          <h2 className="mb-6 font-default text-4xl font-bold tracking-tight text-foreground md:text-5xl lg:text-6xl">
            Seafood Sourced the Right Way
          </h2>
          <p className="max-w-2xl font-sans text-lg text-muted-foreground md:text-xl">
            Preserving the ocean's bounty for generations to come through sustainable practices and deep respect for our maritime heritage.
          </p>
        </div>

        {}
        <div className="mb-16 grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4 md:mb-24">
          {highlights.map((item, i) => {
          const Icon = item.icon;
          return <div key={i} data-index={i} className="group flex flex-col items-center text-center md:items-start md:text-left">
                {}
                <div className="mb-6 flex h-16 w-16 items-center justify-center rounded-lg border border-border bg-card shadow-sm transition-colors duration-300 group-hover:border-primary group-hover:bg-primary/5">
                  <Icon className="h-8 w-8 text-primary" strokeWidth={1.5} />
                </div>
                
                <h3 className="mb-3 flex items-center font-default text-xl font-semibold text-foreground">
                  <span className="mr-2 font-mono text-sm font-normal text-muted-foreground">
                    0{i + 1} //
                  </span>
                  {item.title}
                </h3>
                
                <p className="font-sans text-base leading-relaxed text-muted-foreground">
                  {item.description}
                </p>
              </div>;
        })}
        </div>

        {}
        <div className="flex flex-col items-center justify-center border-t border-border pt-12">
          <div className="mb-8 h-1 w-1 bg-foreground"></div> {}
          <Button asChild size="lg" className="rounded-md bg-secondary px-10 py-6 font-mono text-sm font-medium uppercase tracking-widest text-secondary-foreground hover:bg-foreground hover:text-background transition-colors duration-300">
            <Link to="/SustainabilityPage">
              Learn About Our Practices
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}